module.exports = __webpack_public_path__ + "static/media/volunteer_network.451af356.webp";